import '@swc/helpers';
import * as React from 'react';

const settingsDefaults = {
    thresholds: []
};
const StockIndicatorContext = /*#__PURE__*/ React.createContext({});
const useStockIndicator = ()=>React.useContext(StockIndicatorContext)
;

export { StockIndicatorContext as default, settingsDefaults, useStockIndicator };
//# sourceMappingURL=StockIndicatorContext.js.map
